import { MarkdownComponent as Markdown } from 'pengi-ui'
import { colors } from '@/constant/colors';
import { useMemo } from 'react';

interface MarkdownComponentProps {
  content: string | null | undefined;
  textStyle?: React.CSSProperties;
}

const MarkdownComponent = ({ content, textStyle }: MarkdownComponentProps) => {
  if (!content) {
    return null;
  }

  const finalTextStyle: React.CSSProperties = useMemo(() => {
    return {
      fontFamily: 'var(--font-display)',
      color: colors.mainTextColor,
      textAlign: 'left',
      ...textStyle,
    }
  }, [textStyle])

  return (
    <Markdown content={content} textStyle={finalTextStyle} tableStyle={{ margin: '0 auto' }} />
  );
};

export default MarkdownComponent;
